import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useDisclosure,
    Button,
    Text,
    Image,
    Center,
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";

interface AlertProps {
    isOpen: boolean;
    errorMsg: string;
    callbackCompleted: () => void;
}

function AlertModal(props: AlertProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (props.isOpen) {
            onOpen();
        } else {
            onClose();
        }
    }, [props.isOpen]);

    const onClickClose = () => {
        onClose();
        props.callbackCompleted();
    };

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClickClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent w="307px" alignSelf={"center"}>
                    <AlertDialogHeader>
                        <Center mt="0.5rem">
                            <Image src="/assets/images/icn_exclaim_circle.svg" />
                        </Center>
                    </AlertDialogHeader>

                    <AlertDialogBody alignSelf={"center"}>
                        <Text
                            fontSize={"0.9375rem"}
                            fontWeight="semibold"
                            whiteSpace={"pre"}
                            align="center"
                        >
                            {props.errorMsg
                                ? props.errorMsg
                                : `일시적 오류로 전화번호 인증을 \n실패했습니다. 다시 시도해 주세요`}
                        </Text>
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            ref={cancelRef}
                            w="100%"
                            h="46px"
                            color="white"
                            bgColor="black"
                            onClick={onClickClose}
                        >
                            확인
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
export default AlertModal;
